import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const points = ['Mostrar tu proceso', 'Mostrar cómo aprendés', 'Mostrar cómo evolucionás'];
export function BeginnerSection() {
  return <section className="px-6 py-32 md:py-40 bg-zinc-50 text-black pt-[90px] pb-[90px]" data-id="element-11">
      <div className="w-full max-w-3xl mx-auto" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-13">
          <h2 className="text-4xl md:text-6xl font-black tracking-tight mb-10 leading-[1.1]" data-id="element-14">
            Si estás empezando, esto te juega a favor
          </h2>
          <p className="text-xl md:text-2xl leading-relaxed font-[600] text-[#0A0A0C]" data-id="element-15">
            No necesitás ser perfecto para conseguir clientes, necesitas :
          </p>
        </motion.div>

        <div className="space-y-5 mb-16" data-id="element-16">
          {points.map((point, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="flex items-center gap-5 bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-17">
              <div className="w-10 h-10 rounded-full bg-black flex items-center justify-center flex-shrink-0" data-id="element-18">
                <Check className="w-5 h-5 text-white" strokeWidth={3} data-id="element-19" />
              </div>
              <span className="text-xl font-medium text-black" data-id="element-20">{point}</span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center bg-black text-white p-8 md:p-12 rounded-3xl" data-id="element-21">
          <p className="text-2xl md:text-4xl font-black tracking-tight leading-tight" data-id="element-22">
            El crecimiento genera más confianza que la perfección.
          </p>
        </motion.div>
      </div>
    </section>;
}